<template>
  <div>
    <button
    class="btn bg-darkgrey p-1 pr-2"
    :class="{'fas fa-caret-square-right': !$store.state.isSidebarOpen, 'fas fa-caret-square-left': $store.state.isSidebarOpen}" 
    @click="toggleSidebar()"></button>
  </div>
</template>

<script>
export default {
  methods: {
    toggleSidebar () {
      this.$store.state.isSidebarOpen = !this.$store.state.isSidebarOpen
    }
  }
}
</script>

<style scoped>
button:hover {
    color: rgba(255, 255, 255, 0.95) !important;
}
button {
  border-radius: 0px;
  border-bottom-right-radius: 0.25rem;
  position: fixed;
  z-index: 1001;
  left: 0;
}

.fas {
  cursor:pointer;
  font-size: 1.5rem;
  padding: 0px;
}
</style>
